// This is global material-ui theme, properties can be changed as needed

import { Color, createMuiTheme } from '@material-ui/core';
import createBreakpoints from '@material-ui/core/styles/createBreakpoints';
import shadows from '@material-ui/core/styles/shadows';

// default breakpoints
const breakpoints = createBreakpoints({
  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
  values: {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
  },
  // This ensures we subtract `0.02px` if we use `max-width` in media queries. Mirroring our existing system
  step: 2,
});

const globalMaterialUITheme = createMuiTheme({
  breakpoints,
  palette: {
    primary: {
      light: '#FFFFFF',
      main: '#000000',
    },
    secondary: {
      main: '#A3A3A3',
    },
    alert: {
      light: '#E7CCCF',
      main: '#B00020',
      dark: '#740031',
    },
    highlight: {
      light: '#F1E8DD',
      main: '#CEB18F',
      dark: '#826646',
    },
    accent: {
      light: '#D7DDEB',
      main: '#7183B0',
      dark: '#384669',
    },
    success: {
      light: '#D8E1D5',
      main: '#758E6D',
      dark: '#3C4B37',
    },
    grays: {
      main: '#000000',
      charcoal: '#242424',
      mine: '#3B3B3B',
      chicago: '#636363',
      dawn: '#A3A3A3',
      alto: '#CCCCCC',
      mercury: '#E1E1E1',
      smoke: '#F2F2F2',
      white: '#FFFFFF',
    },
  },
  shape: {
    borderRadius: 0,
  },
  spacing: 8,
  shadows,
});

export default globalMaterialUITheme;

declare module '@material-ui/core/styles/createPalette' {
  // eslint-disable-next-line
  interface Palette {
    accent: Palette['info'];
    alert: Palette['error'];
    highlight: Palette['warning'];
    success: Palette['highlight'];
    grays: Palette['common'];
  }
  // eslint-disable-next-line
  interface PaletteOptions {
    primary?: SimplePaletteColorOptions | Partial<Color> | undefined;
    success?: SimplePaletteColorOptions | Partial<Color> | undefined;
    secondary?: SimplePaletteColorOptions | Partial<Color> | undefined;
    accent: SimplePaletteColorOptions;
    alert: SimplePaletteColorOptions;
    highlight: SimplePaletteColorOptions;
    grays: SimplePaletteColorOptions;
  }
  interface SimplePaletteColorOptions {
    main: string;
    light?: string | undefined;
    dark?: string | undefined;
    charcoal?: string | undefined;
    mine?: string | undefined;
    chicago?: string | undefined;
    dawn?: string | undefined;
    alto?: string | undefined;
    mercury?: string | undefined;
    smoke?: string | undefined;
    white?: string | undefined;
  }
  interface CommonColors {
    main: string;
    light?: string | undefined;
    dark?: string | undefined;
    charcoal?: string | undefined;
    mine?: string | undefined;
    chicago?: string | undefined;
    dawn?: string | undefined;
    alto?: string | undefined;
    smoke?: string | undefined;
    mercury?: string | undefined;
    white: string;
  }
}
